import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Divider from "material-ui/Divider";
import TextField from "material-ui/TextField";
import "./index.css";

export function LoginView(props) {
  const { login, authErrCode } = props;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState("");

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    login({ email, password });
    setEmail("");
    setPassword("");
  };

  useEffect(() => {
    let authErrCodeStatus = authErrCode && authErrCode.signin && authErrCode.signin.status;

    let newErrMsg = "";
    if (authErrCodeStatus === 401) {
      newErrMsg = authErrCode.signin.message;
    } else if (authErrCodeStatus < 500 && authErrCodeStatus > 399) {
      newErrMsg = "Invalid email or password!";
    } else if (authErrCodeStatus > 499) {
      newErrMsg = "Server error!";
    }
    setErrMsg(newErrMsg);
  }, [authErrCode]);

  return (
    <div className="inputPageContainer">
      <div className="inputPage">
        <h1>Login</h1>
        <form onSubmit={handleSubmit}>
          <TextField
            hintText="Email"
            underlineShow={false}
            className="inputRow"
            fullWidth={true}
            type="email"
            name="email"
            value={email}
            onChange={handleChangeEmail}
          />
          <Divider />
          <TextField
            hintText="Password"
            underlineShow={false}
            className="inputRow"
            fullWidth={true}
            type="password"
            name="password"
            value={password}
            onChange={handleChangePassword}
          />
          <Divider />
          <button className="pink forgotPasswordButton">Log In</button>
        </form>
        <div className="forgotPassword">
          <Link to="/">Don't have an account?</Link>
        </div>
        <div className="forgotPassword">
          <Link to="/forgot">Forgot your password?</Link>
        </div>
        <p style={{ textAlign: "center", marginTop: "20px", color: "red" }}>{errMsg}</p>
      </div>
    </div>
  );
}

